<template>
  <div class="col-md-12 storage_devices_list">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="form_select">
          <fg-input
              v-model="filter.fid"
              type="text"
              :placeholder="translate('storage.device_fid')"
              :label="translate('storage.device_fid')"
              :clearable="true"
          />
        </div>

        <div class="form_select">
          <label> {{ translate("storage.status") }} </label>
          <tree-select
              :options="status_list"
              v-model="filter.status"
              :multiple="false"
              :clearable="true"
              :placeholder="translate('storage.status')"
          />
        </div>

        <div class="form_select">
          <label> {{ translate('storage.device_sku') }} </label>
          <tree-select
              :options="device_sku_list"
              v-model="filter.device_sku_id"
              :multiple="false"
              :clearable="true"
              :placeholder="translate('storage.device_sku')"
          />
        </div>

        <div class="form_select">
          <label> {{ translate('storage.device_model_name') }} </label>
          <tree-select
              :options="model_list"
              v-model="filter.model_name"
              :multiple="false"
              :clearable="true"
              :placeholder="translate('storage.device_model_name')"
          />
        </div>

        <div class="form_select">
          <label> {{ translate('storage.defect') }} </label>
          <tree-select
              :options="defect_list"
              v-model="filter.defect"
              :multiple="false"
              :clearable="true"
              :placeholder="translate('storage.defect')"
          />
        </div>

        <div class="form_select"></div>

        <div class="buttons">
          <span
              v-if="storage_devices_list.length > 0"
              class="btn btn-warning btn-fill text-center"
              @click.prevent="copy_fid()"
          >
              Copy FID
            </span>
        </div>
      </div>
    </div>

    <div class="response_table" v-if="storage_devices_list.length > 0">
      <table>
        <thead>
          <tr>
            <th scope="col" class="w5per">
              №
            </th>
            <th scope="col" class="w7per">
              {{ translate('storage.date') }}
            </th>
            <th scope="col" class="w30per">
              {{ translate('storage.client_order_name') }}
            </th>
            <th scope="col" class="w10per">
              {{ translate('storage.device_name') }}
            </th>
            <th scope="col" class="w10per">
              {{ translate('storage.device_sku') }}
            </th>
            <th scope="col" class="w10per">
              {{ translate('storage.device_model_name') }}
            </th>
            <th scope="col" class="w7per">
              {{ translate('storage.status') }}
            </th>
            <th scope="col" class="w10per">
              {{ translate('storage.defect') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <StorageDevicesListItem
              v-for="(storage_device, storage_key) in storage_devices_list"
              :key="storage_key"
              :storage_key="storage_key"
              :storage_device="storage_device"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import StorageDevicesListItem from "./Item/Index.vue";

export default {
  name: 'StorageDevicesList',
  components: {
    StorageDevicesListItem
  },
  data () {
    return {
      storage_devices_list: [],
      check_link: true,
      filter:{
        status: null,
        defect: null,
        model_name: null,
        device_sku_id: null,
        fid: ""
      },
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  computed:{
    device_sku_list() {
      return this.$store.getters.getDeviceSkus.map((sku) => {
        return {id: sku.id, label: sku.title}
      })
    },
    status_list(){
      return this.$store.getters.getStorageListInfo.statuses.map((status) => {
        return { id: status.id, label: this.translate("storage.statuses." + status.title) }
      })
    },
    defect_list(){
      return this.$store.getters.getStorageListInfo.defects.map((status) => {
        return { id: status.id, label: this.translate("storage.defects." + status.title) }
      })
    },
    model_list(){
      return this.$store.getters.getDeviceModels.map((client) => {
        return { id: client.name, label: client.name }
      })
    }
  },

  watch:{
    filter:{
      deep: true,
      handler(){
        this.load_storage_devices_list()
      }
    }
  },

  activated () {
    this.load_storage_devices_list()
  },

  methods: {
    copy_fid(){
      let string = ""
      let devices = [...this.storage_devices_list]
      devices.sort((a, b) => a.device_fid > b.device_fid ? 1 : -1).forEach(device => {
        string += `${device.device_fid}\n`
      })
      this.copy_to_clipboard(string)
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    load_storage_devices_list(){
      let filter = {...this.filter}
      Object.keys(filter).forEach((key) => {
        if (filter[key] === "" || filter[key] === null || filter[key] === undefined) delete filter[key]
      })
      this.$http.v1.getStorageDevicesList(filter, (response) => {
        if (response.data){
          this.storage_devices_list = response.data
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang="scss" scoped>

.storage_devices_list{
  height: 100%;
  display: flex;
  flex-direction: column;
  .main_filters{
    top: 20px;
  }

  .header{
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 10px;
    flex: 1;
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .search_user{
        margin-bottom: 0;
        width: 100%;
      }
      .btn{
        width: 30%;
      }
    }
    .form_select{
      flex: 1;
      max-width: 25%;
      .vue-treeselect{
        margin-bottom: 0;
      }
      .form-group{
        margin-bottom: 0;
      }
    }
    .buttons{
      flex: 1;
      .btn{
        width: 100%;
        padding: 0 10px;
      }
    }
  }

  .response_table{
    padding-left: 0;
    padding-right: 0;
    th{
      font-size: 12px;
    }
  }
}

@media (max-width: 500px){
  .header{
    .form{
      width: 100%;
      .filter{
        min-width: max-content;
        margin: 0 10px;
      }
    }
    .btn{
      b{
        display: none;
      }
      width: 20%;
      min-width: inherit;
    }
    .search_user{
      width: 80%;
    }
  }

}
</style>
